export default __webpack_public_path__ + "static/api-3a186817d2936f95501612aeb3012c60.png";